export default __webpack_public_path__ + "media/video-game-count-and-more-63828.4f400681.mp3";